<template>
  <div class="info-region-container">
    <div class="all-content-container" v-allow="'0603'" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>分组离线配置</h4>
          <el-button type="primary" class="adduser" @click="handleAdd()">添加</el-button>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="分组名称：" prop="groupId">
            <el-cascader v-model="groupIdArr" placeholder="请选择分组名称" :show-all-levels="false" :options="groupArray" :props="optionProps" clearable @change="changeTreeItem"></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="searchKey()">查询</el-button>
            <el-button type="button" ass="button" @click="reset()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="分组名称" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.groupName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="离线模板" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.modelOfflineSettingsName }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleUpdate(scope.row)" type="text">编辑</el-button>
                <el-button style="margin-left: -1rem;" type="text" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
          </div>
        </div>
        <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
          <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="分组名称：" prop="groupIdArr">
                  <el-cascader v-model="ruleForm.groupIdArr" placeholder="请选择分组名称" :show-all-levels="false" :options="groupArray" :props="optionProps" clearable @change="changeTreeItem2"></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="离线模板：" prop="modelOfflineSettingsId">
                  <el-select v-model="ruleForm.modelOfflineSettingsId" placeholder="请选择离线模板" clearable>
                    <el-option v-for="(item, index) in offlineArray" :label="item.name" :value="item.id" :key="index"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose()">取消</el-button>
            <el-button type="primary" @click="handleSave()">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        groupId: '',
        modelOfflineSettingsId: ''
      },
      groupIdArr: [],
      ruleForm: {
        // 添加、编辑弹窗表单
        id: undefined,
        groupId: '',
        groupIdArr: [],
        modelOfflineSettingsId: ''
      },
      rules: {
        // 添加、编辑弹窗表单规则
        groupIdArr: [
          {
            required: true,
            message: '请选择分组名称',
            trigger: 'change'
          }
        ],
        modelOfflineSettingsId: [
          {
            required: true,
            message: '请选择离线模板',
            trigger: 'change'
          }
        ]
      },
      total: 0, // 总数
      tableData: [],
      dialogVisible: false,
      title: '添加离线配置', // 添加、编辑弹窗标题
      groupArray: [], // 分组数组
      offlineArray: [], // 离线模板数组
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        expandTrigger: 'hover'
      },
      groupArray: [] // 分组
    }
  },
  created() {
    // 查询
    this.searchKey()

    // 获取分组列表
    this.getGroupList()

    // 获取离线模板列表
    this.getModelOfflineSettingsList()
  },
  methods: {
    // 查询
    searchKey() {
      this.searchForm.pageNum = 1
      this.getDeviceGroupOfflineList()
    },
    // 分页查询
    handleCurrentChange: function(currentPage) {
      this.searchForm.pageNum = currentPage
      this.getDeviceGroupOfflineList()
    },
    // 重置
    reset() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        groupId: '',
        modelOfflineSettingsId: ''
      }
      this.groupIdArr = []
      this.searchKey()
    },
    // 获取设备分组告警列表
    getDeviceGroupOfflineList() {
      this.isloading = true
      this.$api.offline.getDeviceGroupOfflineList(this.searchForm).then(res => {
        this.total = res.count
        this.tableData = res.data
        this.isloading = false
      })
    },
    // 删除
    handleDel(row) {
      this.$confirm('是否确定删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$api.offline.delDeviceGroupOffline(row.id).then(res => {
          if (res.code == 200) {
            this.$toaster.ok(res.msg)
            this.searchKey()
          }
        })
      })
    },
    // 添加
    handleAdd() {
      this.title = '添加分组离线配置'
      this.ruleForm.id = ''
      this.dialogVisible = true
    },
    // 编辑
    handleUpdate(row) {
      this.title = '编辑分组离线配置'
      this.dialogVisible = true
      this.ruleForm.id = row.id

      // 获取设备分组离线
      this.getDeviceGroupOffline(row.id)
    },
    // 获取设备分组离线
    getDeviceGroupOffline(id) {
      //根据ID详情
      this.$api.offline.getDeviceGroupOffline({ id: id }).then(res => {
        if (res.code == 200) {
          res.data.groupIdArr = this.getGroupIdArr(res.data.groupId)
          console.log(res.data.groupIdArr)
          this.ruleForm = res.data
        }
      })
    },
    // 保存
    handleSave() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.$api.offline.saveDeviceGroupOffline(this.ruleForm).then(res => {
            if (res.code == 200) {
              this.$toaster.ok(res.msg)
              this.handleClose()
              this.searchKey()
            }
          })
        } else {
          this.$toaster.error('保存失败，请先完善配置信息')
        }
      })
    },
    // 关闭添加编辑弹窗
    handleClose() {
      this.$refs['ruleForm'].resetFields()
      this.dialogVisible = false
    },
    // 获取分组列表
    getGroupList() {
      this.$api.system.getConfigGroupTree(0).then(res => {
        if (res.code == 200) {
          this.groupArray = res.data
        }
      })
    },
    // 获取离线模板列表
    getModelOfflineSettingsList() {
      this.$api.offline.getModelOfflineSettingss().then(res => {
        if (res.code == 200) {
          this.offlineArray = res.data
        }
      })
    },
    // 分组下拉
    changeTreeItem(val) {
      this.searchForm.groupId = val[val.length - 1]
      // if (val && val.length == 3) {
      // } else {
      //   this.searchForm.groupId = ''
      //   this.groupIdArr = []
      // }
      this.searchKey()
    },
    // 分组下拉
    changeTreeItem2(val) {
      this.ruleForm.groupId = val[val.length - 1]
      // if (val && val.length == 3) {
      // } else {
      //   this.ruleForm.groupId = ''
      //   this.ruleForm.groupIdArr = []
      // }
    },
    // 获取分组数组id
    getGroupIdArr(id) {
      var groupIdArr = []
      console.log(id)
      this.groupArray.forEach(val => {
        // 1级分组
        if (val.children) {
          val.children.forEach(val2 => {
            console.log(val2)
            if (val2.id == id) {
              groupIdArr = [val.id, val2.id]
            }
            // 2级分组
            // if (val2.children) {
            //   val2.children.forEach(val3 => {
            //     // 3级分组
            //     // if (val3.id == id) {
            //     //   groupIdArr = [val.id, val2.id, val3.id]
            //     // }
            //   })
            // }
          })
        }
      })

      return groupIdArr
    }
  }
}
</script>

<style lang="scss" scoped>
.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>
